import React, { useState } from "react";
import useTable from "../../../../shared/table/useTable";


import { Link } from "react-router-dom"

import {
  CircularProgress,
  IconButton,
	TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";

const headCells = [
	{id: "companyCode", label: "โค้ดบริษัท"},
	{id: "companyName", label: "ชื่อบริษัท"},
	{id: "employee", label: "จำนวนพนักงาน"},
	{id: "contact", label: "ผู้ติดต่อ"},
	{id: "contactEmail", label: "อีเมล"},
	{id: "actions", label: ""}
]

const DataTable = (props) => {
	const { companies, isLoading, deleteModal, setDeleteModal } = props;

	const [filterFn, setFilterFn] = useState({
		fn: (items) => {
			return items;
		},
	});

	const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = 
		useTable(companies, headCells, filterFn);

	return(
		<div>
      <div style={{overflowX: "auto"}}>
        <TblContainer>
          <TblHead />
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : (
              (recordsAfterPagingAndSorting().length > 0 &&
                recordsAfterPagingAndSorting().map((item) => (
                  <TableRow key={item.companyCode}>
                    <TableCell style={{minWidth: 100, maxWidth: 100, textOverflow: "ellipsis", overflow: "hidden", wordBreak: "break-word"}}>{item.companyCode}</TableCell>
                    <TableCell style={{minWidth: 200, maxWidth: 200, textOverflow: "ellipsis", overflow: "hidden", wordBreak: "break-word"}}>{item.companyName}</TableCell>
                    {/* <TableCell style={{minWidth: 200, maxWidth: 200, textOverflow: "ellipsis", overflow: "hidden", wordBreak: "break-word"}}>{item.company}</TableCell> */}
                    <TableCell style={{minWidth: 80, maxWidth: 80, textOverflow: "ellipsis", overflow: "hidden", wordBreak: "break-word"}}>{item.employee}</TableCell>
                    <TableCell style={{minWidth: 200, maxWidth: 200, textOverflow: "ellipsis", overflow: "hidden", wordBreak: "break-word", whiteSpace: "pre-line"}}>{item.contact}</TableCell>
                    <TableCell style={{minWidth: 200, maxWidth: 200, textOverflow: "ellipsis", overflow: "hidden", wordBreak: "break-word", whiteSpace: "pre-line"}}>{item.contactEmail}</TableCell>
                    <TableCell align="right">
                        <IconButton
                          onClick={()=>{setDeleteModal({
                            ...deleteModal,
                            isOpen: true,
                            companyCode: item.companyCode
                          })}}
                        >
                            <DeleteForeverIcon sx={{ color: "#e53935" }} />
                        </IconButton>
                    </TableCell>
                  </TableRow>
                ))) || (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Data
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </TblContainer>
      </div>
			<TblPagination />
		</div>
	)
}

export default DataTable;